export default __webpack_public_path__ + "static/media/light.9b045e2e.svg";